import React from "react";
import './front_Page_Colums.css'

const Columns = () => 
  <div className="table">
    <div className="colum">
    <h1>
            About
        </h1>
        <p><br></br></p>
        <p>This is where I will describe myself and my various hobbies, what I got up to 
            in college and university, and other interest that I may have. 
            <br>
            </br><br></br>Hoping that
            this shall help you understand me better.
            <br></br>
        </p>
    </div>
    <div className="colum">
    <h1>
            Resume
        </h1>
        <p><br></br></p>
        <p>This will contain a nicely designed layout of my CV. This CV will contain myself
            job experence, educational experience, qualifications, and skills.
            <br></br>
            <br></br>
            This will be able to be downloaded by either PDF or Word Docx.
            <br></br>
        </p>
    </div>
    <div className="colum">
    <h1>
            Projects
        </h1>
        <p><br></br></p>
        <p>While a network engineer at heart, I am always wanting to push myself into
            new paths and skills within the tech sphere. Here I will list and document them.
            <br></br>
            <br></br>
            These will include GitHub repositories if nessesary.
            <br></br>
        </p>
    </div>
    <div className="colum">
        <h1>
            Blogs
        </h1>
        <p><br></br></p>
        <p>While I am not the most adventurous person, I do think that everyone should have 
            a place where they can record and look back on some fond moments. This is where that will be.
            <br></br>
            <br></br>
            Here's to the good times.
            <br></br>
        </p>
    </div>
  </div>

export default Columns